<note> Temp footer until global nav and footer ready </note>

<template>
	<footer id="launcher-footer" class="footer">
		<a class="nexon-logo-footer" :href="portalUrl" :target="hrefTarget">
			<svgIcon iconHolderClass="logo" iconId="nexon-logo-full" />
		</a>

		<div class="copyright">{{ $t('copyright', [currentYear]) }}</div>

		<div
			v-if="region === 'global'"
			class="locale"
			ref="select"
			v-click-outside="close"
			:class="{ 'show-languages': showLanguage }"
		>
			<div
				class="current-language"
				@click="toggle();"
				@keydown.esc.stop.prevent="close"
				@keydown.space.stop.prevent="toggle"
				@keydown.enter.stop.prevent="toggle"
			>
				<svgIcon iconHolderClass="icon-locale" iconId="icon-globe" />
				<span>{{ $t(`languages.${$i18n.locale}`) }}</span>
			</div>

			<ul class="languages list-unstyled" :class="{ 'show-languages': showLanguage }">
				<li v-for="list in languageList" :key="list">
					<a @click="setLang(`${list.split('-')[0]}`);">
						{{ $t(`languages.${list.split('-')[0]}`) }}
					</a>
				</li>
			</ul>
		</div>
	</footer>
</template>

<script>
import svgIcon from '@arena/toolkit/src/components/common/icon-svg';
import clickOutside from '../../utils/click-outside';

const localeLookup = {
	de: 'de_DE',
	en: 'en_US',
	es: 'es_419',
	fr: 'fr_FR',
	it: 'it_IT',
	pl: 'pl_PL',
	pt: 'pt_BR',
	th: 'th_TH',
	tr: 'tr_TR',
	zh: 'zh_TW',
};

export default {
	name: 'globalFooter',
	components: {
		svgIcon,
	},
	directives: {
		clickOutside,
	},
	data() {
		return {
			currentYear: new Date().getFullYear(),
			showLanguage: false,
		};
	},
	computed: {
		portalUrl() {
			return this.$store.state.configurations.portal_url;
		},
		hrefTarget() {
			return this.$store.state.channel === 'web' ? '_self' : '_blank';
		},
		logoutUrl() {
			return `/account/${this.$i18n.locale}/logout`;
		},
		languageList() {
			return this.$store.state.configurations.languages;
		},
	},
	methods: {
		close() {
			this.showLanguage = false;
		},
		toggle() {
			this.showLanguage = !this.showLanguage;
		},
		select() {
			this.toggle();
		},
		setLang(lang) {
			this.$i18n.locale = lang;
			this.$cookie.set('i18next', this.$i18n.locale);
			this.showLanguage = false;
			if (typeof window.launcherData !== 'undefined') {
				// The following function is injected into window by the launcher
				window.launcherLanguageChange(localeLookup[lang]);
			}
			this.$router.push({ params: { locale: lang } });
		},
	},
};
</script>

<style lang="less" scoped>
.footer {
	background-color: #262626;
	padding: 16px 20px 0;
	font-size: 12px;
	text-align: center;
	position: absolute; //temp positioning
	bottom: 0;
	width: 100%;

	.copyright {
		vertical-align: top;
		display: inline-block;
		margin: 2px 5px 8px;
		line-height: 1.5em;
	}
	.locale {
		display: inline-block;
		position: relative;
		margin: 2px 5px 10px;
		&.show-languages,
		.show-languages {
			display: inline-block;
		}
		.icon-locale {
			width: 15px;
			height: 15px;
			margin-right: 10px;
		}
		.current-language {
			cursor: pointer;
			&:hover {
				color: #00decb;
			}
		}
		span {
			margin-top: 2px;
			vertical-align: top;
			display: inline-block;
		}
	}
	ul {
		display: none;
		position: absolute;
		width: 120px;
		text-align: left;
		top: -205px;
		left: 25px;

		background-color: #161616;

		li {
			position: relative;
			line-height: 2em;
			&:hover {
				background-color: #00decb;
			}
			a {
				display: inline-block;
				padding: 2px 15px;
				cursor: pointer;
			}
		}
	}
}
.logo {
	width: 100px;
	height: 25px;
	margin: 0 5px 10px;
}
.nexon-logo-footer {
	vertical-align: top;
	display: inline-block;
}
@media (max-width: 740px) {
	.footer {
		padding-top: 30px;
	}
}
@media (max-width: 480px) {
	.footer {
		padding: 20px 10px 10px;
		.logo,
		.locale,
		.copyright {
			margin-bottom: 10px;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/layout/global-footer.vue